import { Injectable } from '@angular/core';

type BannerMode = 'ask' | 'help' | 'hidden';

@Injectable({ providedIn: 'root' })
export class FcmPermissionService {
  private LS_KEY = 'fcmPermissionAsked';          // pamięć trwała (localStorage)
  private LS_LAST_PROMPT = 'fcmLastPromptAt';
  private SS_KEY_SESSION = 'fcmPromptedThisSession'; // pamięć tylko na obecną sesję (sessionStorage)
  // private REASK_MS = 7 * 24 * 60 * 60 * 1000;    // safety: max co 7 dni

  hasBrowserSupport(): boolean {
    return typeof window !== 'undefined' && 'Notification' in window;
  }

  getBrowserPermission(): NotificationPermission | 'unsupported' {
    if (!this.hasBrowserSupport()) { return 'unsupported'; }
    return Notification.permission; // 'default' | 'granted' | 'denied'
  }

  // ---- pamięć trwała ----
  // isAppPrompted(): boolean {
  //   try { return localStorage.getItem(this.LS_KEY) === '1'; } catch (_) { return false; }
  // }
  markPrompted(): void {
    try {
      localStorage.setItem(this.LS_KEY, '1');
      localStorage.setItem(this.LS_LAST_PROMPT, String(Date.now()));
      sessionStorage.setItem(this.SS_KEY_SESSION, '1'); // też znacznik sesyjny
    } catch (_) {}
  }
  unmarkPrompted(): void {
    try {
      localStorage.removeItem(this.LS_KEY);
      localStorage.removeItem(this.LS_LAST_PROMPT);
      sessionStorage.removeItem(this.SS_KEY_SESSION);
    } catch (_) {}
  }

  // ---- pamięć sesyjna (żeby pytać raz na SESJĘ) ----
  isPromptedThisSession(): boolean {
    try { return sessionStorage.getItem(this.SS_KEY_SESSION) === '1'; } catch (_) { return false; }
  }
  markPromptedThisSession(): void {
    try { sessionStorage.setItem(this.SS_KEY_SESSION, '1'); } catch (_) {}
  }

  /** Czy (i jaki) baner pokazać TERAZ. Dla 'default' pokazuj, ale max raz na sesję. */
  getBannerMode(): BannerMode {
    if (!this.hasBrowserSupport()) { return 'hidden'; }
    const perm = Notification.permission;

    if (perm === 'default') {
      return this.isPromptedThisSession() ? 'hidden' : 'ask';
    }
    if (perm === 'denied') { return 'help'; } // promptu i tak nie pokażemy
    return 'hidden'; // granted
  }

  /** PROŚBA o zgodę – wywołuj tylko z gestu użytkownika (klik). */
  async hardRequestPermissionOnce(): Promise<NotificationPermission | 'unsupported'> {
    if (!this.hasBrowserSupport()) { return 'unsupported'; }
    const state = Notification.permission;
    if (state === 'granted') { return 'granted'; }
    if (state === 'denied') { return 'denied'; }
    try {
      this.markPrompted(); // zapamiętaj, że już pytaliśmy
      return await Notification.requestPermission(); // 'granted' | 'denied' | 'default'
    } catch {
      return 'default';
    }
  }

  /** Nasłuch zmian uprawnień (np. ręczna zmiana w kłódce). */
  onPermissionChange(cb: (state: 'granted' | 'denied' | 'prompt') => void) {
    const anyNav: any = navigator;
    if (!anyNav.permissions || !anyNav.permissions.query) { return; }
    try {
      anyNav.permissions.query({ name: 'notifications' as any })
        .then((status: any) => { status.onchange = () => cb(status.state as any); })
        .catch(() => {});
    } catch {}
  }
}
